import { SymbolColor } from "./Symbol";
import symbolColors from "./symbol-colors";

export default function isSymbolColor(color: string): color is SymbolColor {
  return symbolColors.includes(color as SymbolColor);
}
